import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { onBannerSearch, onBannerSubmit } from "../../controller/BannerController";
import 'react-toastify/dist/ReactToastify.css';
import toast, { Toaster } from 'react-hot-toast';
import AuthUtility from "../../util/AuthUtility";
import { BannerModel } from "../../dto/banner/BannerModel";
import { Col, Button, Row, Container, Form } from 'react-bootstrap';
import { BannerEntity } from "../../dto/banner/BannerEntity";
import { FileModel } from "../../dto/FileModel";
import { onCategoryList, onCategorySearch } from "../../controller/CategoryController";
import { CategoryEntity } from "../../dto/category/CategoryEntity";
import { onProductSearch } from "../../controller/ProductController";
import { ProductSearch } from "../../dto/product/ProductSearch";
import { onUserSearch } from "../../controller/UserController";
import { UserSearch } from "../../dto/User/UserSearch";
import { UserEntity } from "../../dto/User/UserEntity";
import { ProductEntity } from "../../dto/product/ProductEntity";
import { BannerSearch } from "../../dto/banner/BannerSearch";
import { CategorySearch } from "../../dto/category/CategorySearch";

interface ReferenceEntity {
    id?: number,
    name?: string
}

type BannerParams = {
    bannerId: string;
};

const BannerDetail = () => {
  const urlParam = useParams<BannerParams>();
  const navigate = useNavigate();
  useEffect(() => {
    if (!AuthUtility.isUserLoggedIn()) {
        navigate("/login");
        window.location.reload();
    } else {
        bannerDetailGet();
    }
  }, []);

  const [entity, setEntity] = useState<BannerEntity>({});
  const [banner, setBanner] = useState<BannerModel>({
    action: 'update',
    entity: entity
  });
  const [bannerPhoto, setBannerPhoto] = useState<FileModel>({
    id: undefined,
    data: undefined,
    width: 1080,
    height: 720
  });
  const [referenceList, setReferenceList] = useState<Array<CategoryEntity>>([]);
  const [validated, setValidated] = useState(false);

  // form references
  const typeRef = useRef<HTMLSelectElement>(null);
  const nameRef = useRef<HTMLInputElement>(null);
  const layoutRef = useRef<HTMLInputElement>(null);
  const orderRef = useRef<HTMLInputElement>(null);
  const startDateRef = useRef<HTMLInputElement>(null);
  const endDateRef = useRef<HTMLInputElement>(null);
  const fileRef = useRef<HTMLInputElement>(null);
  const referenceRef = useRef<HTMLUListElement>(null);
  
  const handleReset = () => {
    if (nameRef.current !== null) {
        nameRef.current.value = "";
    }
    if (layoutRef.current !== null) {
        layoutRef.current.value = "";
    }
    if (orderRef.current !== null) {
        orderRef.current.value = "";
    }
    if (startDateRef.current !== null) {
        startDateRef.current.value = "";
    }
    if (endDateRef.current !== null) {
        endDateRef.current.value = "";
    }
    if (fileRef.current !== null) {
        fileRef.current.value = "";
    }
  }

  const bannerDetailGet = async () => {
    var bannerSearch: BannerSearch = {
        ids: new Array<number>(parseInt(urlParam.bannerId!)),
        offset: 0,
        limit: 1
    }
    const response = await onBannerSearch(bannerSearch);
    const bann: BannerEntity = response.data.beans[0];
    var startDateStr = bann.startDate!.toString().split("T")[0];
    var endDateStr = bann.endDate!.toString().split("T")[0];
    delete bann['photo'];
    delete bann['createdDate'];
    delete bann['startDate'];
    delete bann['endDate'];

    if (bann.type === "PRODUCT") {
        let search: ProductSearch = {
            // id: bann.referenceId,
            offset: 0,
            limit: 1
        }
        let prodResp = await onProductSearch(search);
        let prod: ProductEntity = prodResp.data.beans[0];
        nameRef.current!.value = prod.title!;
    } else if (bann.type === "CATEGORY") {
        let search: CategorySearch = {
            // id: bann.referenceId,
            offset: 0,
            limit: 1
        }
        let catResp = await onCategorySearch(search);
        let cat: CategoryEntity = catResp.data.beans[0];
        nameRef.current!.value = cat.name!;
    } else if (bann.type === "USER") {
        let search: ProductSearch = {
            // id: bann.referenceId,
            offset: 0,
            limit: 1
        }
        let userResp = await onUserSearch(search);
        let user: UserEntity = userResp.data.beans[0];
        nameRef.current!.value = user.individualProfile?.firstName + " - " + user.nickname;
    }

    setBanner({
        ...banner,
        entity: bann
    });
    setEntity({
        type: bann.type,
        layoutNo: bann.layoutNo,
        ordr: bann.ordr,
        startDateStr: startDateStr,
        endDateStr: endDateStr
    });
  }

  const bannerFormValidate = async (event: React.FormEvent) => {
    // bannerSubmit(event);

    const form = event.currentTarget as HTMLFormElement;
    if (form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
    } else {
        bannerSubmit(event);
    }
    setValidated(true);
  }

  const bannerSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    console.log(banner);
    console.log(bannerPhoto);
    try {
        const response = await onBannerSubmit(banner, bannerPhoto);
        if (response !== undefined) {
            if (response.status === 0) {
                toast.success(response.msg);
                bannerDetailGet();
            } else {
                toast.error(response.msg);
            }
        }
    } catch(e: any) {
        toast.error("Амжилтгүй");
    }
    typeRef.current!.value = "";
    handleReset();
    setValidated(false);
  }

  const categoryListGet = async (name: string) => {
    const response = await onCategoryList(undefined, name);
    var ref: Array<ReferenceEntity> = [];
    var beans: Array<CategoryEntity> = response.data.beans;
    for (var i = 0; i < beans.length; i++) {
        var e: ReferenceEntity = {
            id: beans[i].id,
            name: beans[i].name
        }
        ref.push(e);
    }
    setReferenceList(ref);
  }

  const productListGet = async (name: string) => {
    const productSearch: ProductSearch = {
        // name: name,
        offset: 0,
        limit: 100000
    }
    const response = await onProductSearch(productSearch);
    var ref: Array<ReferenceEntity> = [];
    var beans: Array<ProductEntity> = response.data.beans;
    for (var i = 0; i < beans.length; i++) {
        var e: ReferenceEntity = {
            id: beans[i].id,
            name: beans[i].title
        }
        ref.push(e);
    }
    setReferenceList(ref);
  }

  const userListGet = async (firstName: string) => {
    const userSearch: UserSearch = {
        name: firstName,
        offset: 0,
        limit: 100000
    }
    const response = await onUserSearch(userSearch);
    var ref: Array<ReferenceEntity> = [];
    var beans: Array<UserEntity> = response.data.beans;
    for (var i = 0; i < beans.length; i++) {
        var e: ReferenceEntity = {
            id: beans[i].id,
            name: beans[i].individualProfile?.firstName + " - " + beans[i].nickname
        }
        ref.push(e);
    }
    setReferenceList(ref);
  }

  const referenceSelector = (e: React.MouseEvent<HTMLLIElement>) => {
    var li = e.target as HTMLLIElement;
    const prevState: BannerEntity = {...banner.entity};
    prevState.referenceId = li.value;
    setBanner({
        ...banner,
        entity: prevState
    })
    nameRef.current!.value =  li.innerText;
    referenceRef.current!.style.display = "none";
  }

  return (
    <Container fluid>
        <div><Toaster position="top-right" reverseOrder={false}/></div>
        <h3><a onClick={() => navigate(-1)}><big>&#8592;</big></a>Banner</h3>
        <Form noValidate validated={validated} 
        onSubmit={bannerFormValidate}>
            <Row className="mb-3">
                <Col sm={6} md={6} lg={6}>
                    <Form.Group controlId="bannerType">
                        <Form.Label>ТӨРӨЛ</Form.Label>
                        <Form.Select ref={typeRef} size="sm" 
                        onChange = {(event) => {
                            const prevState: BannerEntity = {...banner.entity};
                            prevState.type = event.target.value;
                            prevState.referenceId = null;
                            setBanner({
                                ...banner,
                                entity: prevState
                            });
                            setEntity({
                                ...entity,
                                type: event.target.value
                            })
                            if (event.target.value === "INFO" || event.target.value === "") {
                                nameRef.current!.value = "";
                                nameRef.current!.disabled = true;
                            } else {
                                nameRef.current!.disabled = false;
                            }
                            referenceRef.current!.style.display = "none";
                        }} 
                        value = {entity.type}
                        required>
                            <option value=""></option>
                            <option value="INFO">INFO</option>
                            <option value="PRODUCT">PRODUCT</option>
                            <option value="CATEGORY">CATEGORY</option>
                            <option value="USER">USER</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                            Төрөл оруулна уу.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col sm={6} md={6} lg={6}>
                    <Form.Group controlId="referenceId">
                        <Form.Label>НЭР</Form.Label>
                        <Form.Control ref={nameRef} size="sm" type="text" 
                        onChange = {(event) => {
                            if (event.target.value.length > 0) {
                                referenceRef.current!.style.display = "block";
                                if (banner.entity.type === "PRODUCT") {
                                    productListGet(event.target.value);
                                } else if (banner.entity.type === "CATEGORY") {
                                    categoryListGet(event.target.value);
                                } else if (banner.entity.type === "USER") {
                                    userListGet(event.target.value);
                                }
                            } else {
                                referenceRef.current!.style.display = "none";
                                setReferenceList([]);
                            }
                        }}
                        autoComplete="off" />
                        <div>
                            <ul className="list-group" ref={referenceRef}>
                                {
                                    referenceList.map((data, idx) => {
                                        return (
                                            <li className="list-group-item list-group-item-action" key={idx} 
                                            onClick={referenceSelector} value={data.id}>{data.name}</li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col sm={6} md={6} lg={6}>
                    <Form.Group controlId="bannerLayout">
                        <Form.Label>БАЙРШЛЫН ДУГААР</Form.Label>
                        <Form.Control ref={layoutRef} size="sm" type="number" 
                        onChange = {(event) => {
                            const prevState: BannerEntity = {...banner.entity};
                            prevState.layoutNo = parseInt(event.target.value);
                            setBanner({
                                ...banner,
                                entity: prevState
                            });
                            setEntity({
                                ...entity,
                                layoutNo: parseInt(event.target.value)
                            });
                        }}
                        value = {entity.layoutNo || ""}
                        required />
                        <Form.Control.Feedback type="invalid">
                            Байршлын дугаар оруулна уу.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col sm={6} md={6} lg={6}>
                    <Form.Group controlId="bannerOrder">
                        <Form.Label>ЭРЭМБЭ</Form.Label>
                        <Form.Control ref={orderRef} size="sm" type="number" 
                        onChange = {(event) => {
                            const prevState: BannerEntity = {...banner.entity};
                            prevState.ordr = parseInt(event.target.value);
                            setBanner({
                                ...banner,
                                entity: prevState
                            });
                            setEntity({
                                ...entity,
                                ordr: parseInt(event.target.value)
                            });
                        }} 
                        value = {entity.ordr || ""}
                        required />
                        <Form.Control.Feedback type="invalid">
                            Эрэмбэ оруулна уу.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col sm={6} md={6} lg={6}>
                    <Form.Group controlId="bannerStartDate">
                        <Form.Label>ХҮЧИНТЭЙ ЭХЛЭХ ХУГАЦАА</Form.Label>
                        <Form.Control ref={startDateRef}
                            type = "date"
                            onChange = {(event) => {
                                const prevState: BannerEntity = {...banner.entity};
                                prevState.startDateStr = event.target.value + " 00:00:00";
                                setBanner({
                                    ...banner,
                                    entity: prevState
                                });
                                setEntity({
                                    ...entity,
                                    startDateStr: event.target.value
                                });
                            }} 
                            value = {entity.startDateStr || ""}
                        required />
                        <Form.Control.Feedback type="invalid">
                            Эхлэх хугацаа оруулна уу.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col sm={6} md={6} lg={6}>
                    <Form.Group controlId="bannerEndDate">
                        <Form.Label>ХҮЧИНТЭЙ ДУУСАХ ХУГАЦАА</Form.Label>
                        <Form.Control ref={endDateRef}
                            type = "date"
                            onChange = {(event) => {
                                const prevState: BannerEntity = {...banner.entity};
                                prevState.endDateStr = event.target.value + " 00:00:00";
                                setBanner({
                                    ...banner,
                                    entity: prevState
                                });
                                setEntity({
                                    ...entity,
                                    endDateStr: event.target.value
                                });
                            }} 
                            value = {entity.endDateStr || ""}
                        required />
                        <Form.Control.Feedback type="invalid">
                            Дуусах хугацаа оруулна уу.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col md={3}>
                    <Form.Group className="mb-3" controlId="categoryFreight">
                        <div style={{ paddingLeft: "1.25rem" }}>
                        <Form.Label className="text-center">Идэвхтэй эсэх</Form.Label>
                        <Form.Switch
                            id="banner-activeFlag"
                            label="Идэвхтэй эсэх"
                            checked={banner.entity.activeFlag ? true : false}
                            onChange={(event) => {
                            const prevState: BannerEntity = {...banner.entity};
                            prevState.activeFlag = event.target.checked;
                            setBanner({
                                ...banner,
                                entity: prevState
                            })
                        }}/>
                        </div>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col sm={6} md={6} lg={6}>
                    <Form.Group controlId="bannerFile" className="mb-3">
                        <Form.Label>ЗУРАГ</Form.Label>
                        <Form.Control ref={fileRef} type="file" accept="image/*" 
                        onChange = {(event: React.ChangeEvent<HTMLInputElement>) => setBannerPhoto({
                            ...bannerPhoto,
                            data: event.target.files ? event.target.files.item(0) : null
                        })}
                        />
                        <Form.Control.Feedback type="invalid">
                            Зураг сонгоно уу.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col sm={1} md={1} lg={1}>
                    <Form.Group controlId="bannerWidth" className="mb-3">
                        <Form.Label>УРТ</Form.Label>
                        <Form.Control type = "number" defaultValue = "1080"
                        onChange = {(event) => {
                            setBannerPhoto({
                                ...bannerPhoto,
                                width: parseInt(event.target.value)
                            });
                        }} />
                    </Form.Group>
                </Col>
                <Col sm={1} md={1} lg={1}>
                    <Form.Group controlId="bannerHeight" className="mb-3">
                        <Form.Label>ӨРГӨН</Form.Label>
                        <Form.Control type = "number" defaultValue = "720"
                        onChange = {(event) => {
                            setBannerPhoto({
                                ...bannerPhoto,
                                height: parseInt(event.target.value)
                            });
                        }} />
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col sm={3} md={3} lg={3}>
                    <Button size="sm" type="submit">
                        Хадгалах
                    </Button>
                </Col>
            </Row>  
        </Form>
    </Container>
  )
}

export default BannerDetail;